import { render } from "./UserConfirmation.vue?vue&type=template&id=79ff22de&scoped=true&ts=true"
import script from "./UserConfirmation.vue?vue&type=script&lang=ts"
export * from "./UserConfirmation.vue?vue&type=script&lang=ts"

import "./UserConfirmation.vue?vue&type=style&index=0&id=79ff22de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ff22de"]])

export default __exports__